import { CREATE_LEAVE, GET_REMAINING_LEAVES, HANDLE_LEAVE, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_REQUEST, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_SUCCESS, FETCH_EMPLOYEES_FOR_CREATE_LEAVE_FAILURE, FETCH_USERS_ROLE_BASED_REQUEST } from './redux.actionTypes';

export const handleLeave = ({ handleSubmit, payload }) => ({
    type: HANDLE_LEAVE,
    meta: { handleSubmit },
    payload,
});

export const createLeave = ({ handleSubmit, payload }) => ({
    type: CREATE_LEAVE,
    meta: { handleSubmit },
    payload,
});

export const getRemainingLeaves = ({ handleSubmit, payload }) => ({
    type: GET_REMAINING_LEAVES,
    meta: { handleSubmit },
    payload,
});

export const fetchEmployeesForCreateLeaveRequest = () => ({
    type: FETCH_EMPLOYEES_FOR_CREATE_LEAVE_REQUEST,
});

export const fetchEmployeesForCreateLeaveSuccess = (data) => ({
    type: FETCH_EMPLOYEES_FOR_CREATE_LEAVE_SUCCESS,
    payload: data,
});

export const fetchEmployeesForCreateLeaveFailure = (error) => ({
    type: FETCH_EMPLOYEES_FOR_CREATE_LEAVE_FAILURE,
    payload: error,
});

export const fetchUsersRoleBasedRequest = () => ({
    type: FETCH_USERS_ROLE_BASED_REQUEST,
});